// extracted by mini-css-extract-plugin
module.exports = {"uikit-overflow__trigger":"uikit-overflow__trigger__1nYqP"};